import vue from "vue";
import { createPinia } from "pinia";
const piniaInstance = createPinia();
(vue as any).options.pinia = piniaInstance;
vue.use({
    install(app) {
        app.use(piniaInstance);
    },
});
//console.debug("initialized pinia");
